import React, { ComponentProps } from 'react';
import { styled } from 'theme';
import { fadeIn } from 'theme/animations';

const StyledAlert = styled('div', {
  // Reset
  boxSizing: 'border-box',

  // Custom
  px: '$2',
  py: '$2',
  fontSize: '$sm',
  letterSpacing: '$wide',
  borderRadius: '$xs',
  textAlign: 'center',
  animation: `${fadeIn} 150ms ease-in-out`,

  variants: {
    status: {
      error: {
        color: '$red800',
        backgroundColor: '$red100',
      },
      success: {
        color: '$green900',
        backgroundColor: '$green100',
      },
      warning: {
        color: '$yellow900',
        backgroundColor: '$yellow100',
      },
    },
  },
});

type AlertProps = ComponentProps<typeof StyledAlert>;

function Alert(props: AlertProps) {
  return <StyledAlert role="alert" {...props} />;
}

export default Alert;
